import {
  EVALUATE_RECORDS_TYPE_OK,
  EVALUATE_RECORDS_TYPE_ERR,
} from "./evaluate-records-type.action";

const InitState = {
  error: null,
  content: null,
};

export default function evaluateRecordsTypeReducer(state = InitState, action) {
  switch (action.type) {
    case EVALUATE_RECORDS_TYPE_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case EVALUATE_RECORDS_TYPE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
